import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppState from '../models/redux/state/app.state';
import { getProfileAPIcall } from '../redux/actions/profile/profile.actions';
import history from './browserHistory';

const useProfileHook = (): void => {
  const dispatch = useDispatch();
  const user = useSelector((state: AppState) => state.auth.user);
  const profile = useSelector((state: AppState) => state.profile.current);

  useEffect(() => {
    if (user && (!profile || profile.url !== user.profile)) {
      dispatch(getProfileAPIcall(user.profile));
    }
  }, [user, profile, dispatch]);
  
  useEffect(() => {
    if (
      user &&
      profile &&
      profile.url === user.profile &&
      !profile.isCompleted &&
      !history.location.pathname.includes('profile')
    ) {
      history.push('/profile');
    }
  }, [user, profile]);
};

export default useProfileHook;
